// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var Avatar__Jsx3 = require("../../atoms/Avatar/Avatar__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function Chat__Jsx3$ChatAvatar(props) {
  var overlayIcon = props.overlayIcon;
  var name = props.name;
  var src = props.src;
  return JsxRuntime.jsx("div", {
              children: overlayIcon !== undefined ? JsxRuntime.jsxs("span", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: overlayIcon,
                                    size: 20,
                                    color: props.iconColor
                                  }),
                              className: "absolute right-[-8%] top-[58%] opacity-40"
                            }),
                        JsxRuntime.jsx(Avatar__Jsx3.make, {
                              src: src,
                              name: name,
                              size: "tiny"
                            })
                      ],
                      className: "relative inline-block"
                    }) : JsxRuntime.jsx(Avatar__Jsx3.make, {
                      src: src,
                      name: name,
                      size: "tiny"
                    }),
              className: "mr-2.5"
            });
}

var ChatAvatar = {
  make: Chat__Jsx3$ChatAvatar
};

exports.ChatAvatar = ChatAvatar;
/* Icon__Jsx3 Not a pure module */
